import React from 'react'
import Users from './users/Users'
import Roles from './roles/Roles'
import { Link, useLocation } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'


const ManageAccess = () => {

    const location = useLocation();
    const currentPath = location.pathname;

    const isActive = (path) => currentPath === path;
    const [buttonType, setButtonType] = React.useState('users')
    const [subButtonType, setSubButtonType] = React.useState('users')
    return (
        <div>
            <div className="p-8 items-center mb-4">
                {/* <h1 className="text-2xl font-bold">Manage Access</h1> */}
                <div className="flex items-center gap-8 mb-4">
                    <button onClick={() => setButtonType("dashboard")} className={`  h-[40px] w-[180px] font-medium rounded-lg ${buttonType === "dashboard" ? "border border-blue-600 bg-gray-100 text-blue-600" : "bg-blue-600 text-white"} `}>
                        Dashboard
                    </button>
                    <Link to={"/admin/all-activities"} > <button onClick={() => {
                        setButtonType("allActivities");

                    }} className={`  h-[40px] w-[180px] font-medium rounded-lg ${buttonType === "allActivities" ? "border border-blue-600 bg-gray-100 text-blue-600" : "bg-blue-600 text-white"} `}>
                        All Activities
                    </button></Link>

                    <Link to={"/admin/email-templates"}> <button onClick={() => setButtonType("emailTemplates")} className={`  h-[40px] w-[180px] font-medium rounded-lg ${buttonType === "emailTemplates" ? "border border-blue-600 bg-gray-100 text-blue-600" : "bg-blue-600 text-white"} `}>
                        Email Templates
                    </button>
                    </Link>
                    <Link to={"/admin/schedule-activities"}> <button onClick={() => setButtonType("scheduleActivities")} className={`  h-[40px] w-[180px] font-medium rounded-lg ${buttonType === "scheduleActivities" ? "border border-blue-600 bg-gray-100 text-blue-600" : "bg-blue-600 text-white"} `}>
                        Schedule Activities
                    </button></Link>
                    <Link to={"/admin/manage-access/users"}> <button onClick={() => setButtonType("users")} className={`  h-[40px] w-[180px] font-medium rounded-lg ${buttonType === "users" ? "border border-blue-600 bg-gray-100 text-blue-600" : "bg-blue-600 text-white"} `}>
                        Manage Access
                    </button></Link>
                </div>
                <div className="flex space-x-4 mb-2">
                    <Link to="/admin/manage-access/users">
                        <button
                        onClick={() => setSubButtonType('users')}
                            className={`h-[40px] w-[180px] font-medium rounded-lg ${isActive("/admin/manage-access/users")
                                   ? "bg-[#FF9348] text-white"
                                    : "border border-[#FF9348] bg-white text-[#FF9348]"
                                }`}
                        >
                            Users
                        </button>
                    </Link>

                    <Link to="/admin/manage-access/roles">
                        <button
                        onClick={() => setSubButtonType('roles')}
                            className={`h-[40px] w-[180px] font-medium rounded-lg ${isActive("/admin/manage-access/roles")
                                    ? "bg-[#FF9348] text-white"
                                    : "border border-[#FF9348] bg-white text-[#FF9348]"
                                }`}
                        >
                            Roles
                        </button>
                    </Link>
                </div>
            </div>
            {subButtonType === 'users' && <Users />}
            {subButtonType === 'roles' && <Roles />}
        </div>
    )
}

export default ManageAccess